module.exports = __webpack_public_path__ + "img/32.4.NH3-N.892c68b4.png";